/* top-bar.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./top-bar.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useContext } from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { useSkipLink } from '../../context/skip-links/skip-links-context';
import { HasCustomThemeContext } from '../top-navigation/themed/has-custom-theme-context';
import { useCustomTheme } from '../top-navigation/themed/use-custom-theme';
import { bannerMountedVar, localSlotLayers, topBarMountedVar, UNSAFE_topBarVar } from './constants';
import { DangerouslyHoistSlotSizes } from './hoist-slot-sizes-context';
import { DangerouslyHoistCssVarToDocumentRoot, HoistCssVarToLocalGrid } from './hoist-utils';
import { usePrefixedUID } from './use-prefixed-id';
var styles = {
  root: "_nd5l8cbt _zulpu2gc _18zrutpp _179rzgxb _1e0c11p5 _yv0e1mfv _4cvr1h6o _bfhkvuon _vchhusvi _4t3i2mmk _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi",
  oldLayoutStyles: "_1rqtc57g",
  newLayoutStyles: "_1j8b18ax"
};
export function TopBar(_ref) {
  var children = _ref.children,
    xcss = _ref.xcss,
    _ref$UNSAFE_height = _ref.UNSAFE_height,
    UNSAFE_height = _ref$UNSAFE_height === void 0 ? 48 : _ref$UNSAFE_height,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Top Bar' : _ref$label,
    _ref$skipLinkLabel = _ref.skipLinkLabel,
    skipLinkLabel = _ref$skipLinkLabel === void 0 ? label : _ref$skipLinkLabel,
    testId = _ref.testId,
    id = _ref.id,
    UNSAFE_theme = _ref.UNSAFE_theme;
  var dangerouslyHoistSlotSizes = useContext(DangerouslyHoistSlotSizes);
  var UID = usePrefixedUID();
  var CID = id ? id : UID;
  useSkipLink(CID, skipLinkLabel);
  var customTheme = useCustomTheme(UNSAFE_theme);
  return /*#__PURE__*/React.createElement(HasCustomThemeContext.Provider, {
    value: customTheme.isEnabled
  }, /*#__PURE__*/React.createElement("header", {
    id: CID,
    "data-layout-slot": true,
    className: ax([styles.root, fg('platform_design_system_nav4_top_nav_columns') ? styles.newLayoutStyles : styles.oldLayoutStyles, xcss]),
    "data-testid": testId
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    ,
    style: customTheme.isEnabled ? customTheme.style : undefined
  }, /*#__PURE__*/React.createElement(HoistCssVarToLocalGrid, {
    variableName: topBarMountedVar,
    value: UNSAFE_height
  }), dangerouslyHoistSlotSizes &&
  /*#__PURE__*/
  // ------ START UNSAFE STYLES ------
  // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
  // When they aren't needed anymore we can delete them wholesale.
  React.createElement(DangerouslyHoistCssVarToDocumentRoot, {
    variableName: UNSAFE_topBarVar,
    value: UNSAFE_height
  })
  // ------ END UNSAFE STYLES ------
  , children));
}